// extracted by css-extract-rspack-plugin
export default {"timestamp":"IssueComment-module__timestamp__wuL6D"};